import React from 'react';
import DENTButton from '../../../Base/Components/DENT/DENTButton/DENTButton';
// @ts-ignore
import styles from './DENTModalOverviewPeriodontalMobility.module.scss';
import useTranslation from '../../../../Hooks/useTranslation';
import useTooth from '../../Hooks/Tooth/useTooth';
import { ToothMobility } from '../../../../graphql/graphql';

const MOBILITY_OPTIONS = [
	{
		title: 'patientTreatment.meddiDENT.dentalCross.mobility.class1',
		type: ToothMobility.Class_1,
	},
	{
		title: 'patientTreatment.meddiDENT.dentalCross.mobility.class2',
		type: ToothMobility.Class_2,
	},
	{
		title: 'patientTreatment.meddiDENT.dentalCross.mobility.class3',
		type: ToothMobility.Class_3,
	},
];

const DENTModalOverviewPeriodontalMobility = () => {
	const {
		periodontal: { getPeriodontal: periodontal, setMobility },
	} = useTooth();
	const { t } = useTranslation();

	return (
		<div className={styles.wrapper}>
			<h5>{t('patientTreatment.meddiDENT.dentalCross.mobility.title')}</h5>
			<div className={styles.buttons}>
				{MOBILITY_OPTIONS.map(option => (
					<DENTButton
						key={option.type}
						title={option.title}
						onClick={() => setMobility(option.type || ToothMobility.None)}
						isSelected={periodontal.mobility === option.type}
					/>
				))}
			</div>
		</div>
	);
};

export default DENTModalOverviewPeriodontalMobility;
